/* eslint-disable max-len */
import { API } from 'shared/utils/apiMiddleware';
import { sanitizeQuery } from 'shared/utils/apiUtil';

class UsageApi {
  // ALERTS
  saveCauAlerts = (alerts) => {
    const query = '/api/v1/usage/alerts';
    // const { id, ...rest } = alerts;
    const result = API.post('billings', query, { body: alerts });
    return result;
  };
  deleteCauAlert = (alertId) => {
    const query = `/api/v1/usage/alerts/${alertId}`;
    const result = API.get('billings', query);
    return result;
  };
  fetchCauAlerts = () => {
    const query = '/api/v1/usage/alerts';
    const result = API.get('billings', query);
    return result;
  };

  // Savings Plans Analyzer
  getSavingsPlansAnalyzerData = async (
    includeFilterParams,
    excludeFilterParams,
    daysToCheck,
    selectedPaymentOption,
    selectedTerm,
    coverage,
  ) => {
    let apiQuery = `/api/v1/usage/sp-analyzer?daysToCheck=${daysToCheck}&paymentOption=${selectedPaymentOption}&term=${selectedTerm}&coverage=${coverage}${includeFilterParams}${excludeFilterParams}`;
    apiQuery = sanitizeQuery(apiQuery);
    const result = await API.get('billings', apiQuery);
    return result;
  };

  // COMMITMENTS *********

  getCommitmentTableData = async (date, commitmentService, linkedAccount, commitmentType) => {
    const apiQuery = `/api/v1/usage/commitment?date=${date}&commitmentType=${commitmentType}&commitmentService=${commitmentService}&linkedAccount=${linkedAccount}`;
    const result = await API.get('billings', apiQuery);
    return result;
  };
  getCommitmentChartsAndStatisticsData = async (date, commitmentType) => {
    const apiQuery = `/api/v1/usage/commitment/commitment-charts?date=${date}&commitmentType=${commitmentType}`;
    const result = await API.get('billings', apiQuery);
    return result;
  };
  getCommitmentRiFlexabilityData = async (arn, startDate, endDate) => {
    const apiQuery = `/api/v1/usage/commitment/ri-flexibility?arn=${arn}&startDate=${startDate}&endDate=${endDate}`;
    const result = await API.get('billings', apiQuery);
    return result;
  };
  getCommitmentgetChargeBackData = async (arn, startDate, endDate) => {
    const apiQuery = `/api/v1/usage/commitment/chargeback?arn=${arn}&startDate=${startDate}&endDate=${endDate}`;
    const result = await API.get('billings', apiQuery);
    return result;
  };
  getServicePlansChargeBackData = async (arn, startDate, endDate) => {
    const apiQuery = `/api/v1/usage/commitment/sp-chargeback?arn=${arn}&startDate=${startDate}&endDate=${endDate}`;
    const result = await API.get('billings', apiQuery);
    return result;
  };

  // AZURE *************

  getAzureStorageUsageData = async (startDate, endDate) => {
    const query = `/api/v1/azure/services/storage?startDate=${startDate}&endDate=${endDate}`;
    const result = await API.get('billings', query);
    return result;
  };
  getAzureDbCostData = async (startDate, endDate) => {
    const query = `/api/v1/azure/services/db-costs?startDate=${startDate}&endDate=${endDate}`;
    const result = await API.get('billings', query);
    return result;
  };

  getAzureRiCoverage = async (startDate, endDate) => {
    const query = `/api/v1/azure/services/ri-coverage?startDate=${startDate}&endDate=${endDate}`;
    const result = await API.get('billings', query);
    return result;
  };

  // KPIS
  getKpiBusinessUnitCoverageData = (service, granularity, startDate, endDate) =>
    API.get(
      'billings',
      `/api/v1/usage/kpis/business-unit-coverage?service=${service}&granularity=${granularity}&startDate=${startDate}&endDate=${endDate}`,
    );

  getKpiCoverageByPricingMethod = (service, granularity, startDate, endDate) =>
    API.get(
      'billings',
      `/api/v1/usage/kpis/pricing-method-coverage?service=${service}&granularity=${granularity}&startDate=${startDate}&endDate=${endDate}`,
    );

  getKpieBusinessUnitReservationUtilization = async (service, granularity, startDate, endDate) =>
    API.get(
      'billings',
      `/api/v1/usage/kpis/business-unit-reservation-utilization?service=${service}&granularity=${granularity}&startDate=${startDate}&endDate=${endDate}`,
    );

  getKpiCashBasis = (granularity, startDate, endDate) =>
    API.get(
      'billings',
      `/api/v1/usage/kpis/cash-basis?granularity=${granularity}&startDate=${startDate}&endDate=${endDate}`,
    );
  getKpiCostPerHour = (service, granularity, startDate, endDate) =>
    API.get(
      'billings',
      `/api/v1/usage/kpis/cost-per-hour?service=${service}&granularity=${granularity}&startDate=${startDate}&endDate=${endDate}`,
    );
  getKpiMonthlyCostPerHour = (service, granularity, startDate, endDate) =>
    API.get(
      'billings',
      `/api/v1/usage/kpis/monthly-cost-per-hour?service=${service}&granularity=${granularity}&startDate=${startDate}&endDate=${endDate}`,
    );
  getKpiQtdCoverageByService = (service, granularity, startDate, endDate) =>
    API.get(
      'billings',
      `/api/v1/usage/kpis/qtd-service-coverage?service=${service}&startDate=${startDate}&endDate=${endDate}`,
    );
  getKpiQtdUtilizationByService = (service, year, startMonth, endMonth) =>
    API.get(
      'billings',
      `/api/v1/usage/kpis/qtd-service-utilization?service=${service}&year=${year}&startMonth=${startMonth}&endMonth=${endMonth}`,
    );
  getKpiSavingsOnDemand = (yearQuarter) =>
    API.get('billings', `/api/v1/usage/kpis/savings-on-demand?yearQuarter=${yearQuarter}`);
}

export default UsageApi;
